import { Request } from '../request';
import { IGetSpecificConditionDetailInput, IGetSpecificConditionDetailResponse } from 'types/helloKlarity';

export const getSpecificConditionDetail = (params: IGetSpecificConditionDetailInput) => Request.post<IGetSpecificConditionDetailResponse>({ url: '/admin-server/provider/profile/condition/specific/detail', params });

export const getSpecificConditionListByProviderId = (providerId: number) => Request.get({ url: `/admin-server/klarity/provider/specific/condition/list/${providerId}` });
